import
{
    encode,
    decode
}
from "base64-arraybuffer";

import WordFileHandler from "../utils/WordFileHandler";
import RequestHelper from "../utils/RequestHelper";
import Config from "../Config";
import Commons from "../utils/Commons";
import { isOauth } from "../_components/oauth/OAuth";

export default class ANPObjectCreator
{
    static createTemplateDocObject = async function(sName)
    {
        let aObjGroup = null;

        if (!Config.aAnpRepo.id)
        {
            throw new Error("Repository ID is missing. Please select proper repository in Report Creator configuration.!");
        }
        // console.log("createTemplateDocObject Config.aAnpRepo", Config.aAnpRepo);

        aObjGroup = await Commons.checkTemplatesObjGroup();
        // console.log("createTemplateDocObject aObjGroup", aObjGroup);

        if (!aObjGroup.hasOwnProperty("id") && aObjGroup.hasOwnProperty("maingroup") && aObjGroup.maingroup.hasOwnProperty("id") && aObjGroup.maingroup.id)
        {
            let aBodyRaw = {
                name: Config.sAnpTemplateObjGroup,
                parentGroupId: aObjGroup.maingroup.id
            };
            await RequestHelper.sendRequestSimple(
            {
                request: Commons.createGatewayRequestUrl(
                {
                    url: Config.anpRequestUrl.createObjectGroup.replace(/%repo_id%/g, Config.aAnpRepo.id),
                    dataType: "json"
                }),
                dataType: "json",
                headers:
                {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(aBodyRaw),
                method: "POST"
            }).then((aResponse) =>
            {
                if (aResponse && aResponse.isErr)
                {
                    console.error(aResponse.message);
                    throw new Error(aResponse.message)
                }
                if (aResponse.hasOwnProperty("group") && aResponse.group.hasOwnProperty("id") && aResponse.group.id)
                {
                    aObjGroup["id"] = aResponse.group.id;
                    aObjGroup["name"] = aResponse.group.name;
                }
                if (aObjGroup.hasOwnProperty("id"))
                {
                    aObjGroup.id = Commons.removeCurlyBracketsFromId(aObjGroup.id);
                }
                else
                {
                    console.error("Cannot create missing objectgroup!");
                    throw new Error("Cannot create missing objectgroup!");
                }
            });
        }

        const aDocObjData = await ANPObjectCreator.createObject(
        {
            class: Commons.isAdoit() ? "C_REPRESENTATION" : "C_DOCUMENT",
            name: sName,
            objGroupId: aObjGroup.id
        });

        return {
            docObject: aDocObjData
        };
    }

    static createObject = async (aParams) =>
    {
        const sClass = aParams.class;
        const sName = aParams.name;
        const sRepoId = Config.aAnpRepo.id;
        const sObjGroupId = aParams.objGroupId;

        let aObjCreatedData = {};

        if (!(
                typeof sClass === "string" && 0 < sClass.length && typeof sName === "string" && 0 < sName.length &&
                typeof sRepoId === "string" && 0 < sRepoId.length && typeof sObjGroupId === "string" && 0 < sObjGroupId.length
            ))
        {
            console.warn("Cannot create new object! Name, class name, repo ID or objectgroup ID is missing!");
            return;
        }

        // const aObjCreateReqUrl = Config.requests.sObjCreate.concat("&repo_id=", sRepoId);
        let aBodyRaw = {
            name: sName,
            groupId: sObjGroupId,
            metaName: sClass
        };
        await RequestHelper.sendRequestSimple(
        {
            request: Commons.createGatewayRequestUrl(
            {
                url: Config.anpRequestUrl.createObject.replace(/%repo_id%/g, Config.aAnpRepo.id),
                dataType: "json"
            }),
            dataType: "json",
            headers:
            {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(aBodyRaw),
            method: "POST"
        }).then((aResponse) =>
        {
            if (aResponse && aResponse.isErr)
            {
                console.error(aResponse.message);
                throw new Error(aResponse.message)
            }
            let aObjCreated = {};
            if (aResponse.hasOwnProperty("item") && aResponse.item.hasOwnProperty("id") && aResponse.item.id)
            {
                aObjCreated["id"] = aResponse.item.id;
                aObjCreated["name"] = aResponse.item.name;
                aObjCreated["artefactType"] = aResponse.item.artefactType;
                aObjCreated["metaName"] = aResponse.item.metaName;
            }
            if (aObjCreated.hasOwnProperty("id"))
            {
                aObjCreatedData = aObjCreated;
                aObjCreatedData.id = Commons.removeCurlyBracketsFromId(aObjCreatedData.id);
            }
        });
        return aObjCreatedData;
    }

    static getCurrentFileEncoded = async () =>
    {
        let sCurrentDocEncoded = "";
        await WordFileHandler.getCurrentFileEncoded().then((aData) =>
        {
            if (!aData.isErr && aData.data)
            {
                sCurrentDocEncoded = aData.data;
            }
            else
            {
                console.warn("Cannot parse current file!");
                throw new Error("Word file error: cannot parse current file!");
            }
        });
        return sCurrentDocEncoded ? sCurrentDocEncoded : null;
    }

    static attachCurrentDocToObject = async (aParams) =>
    {
        const sRepoId = Config.aAnpRepo.id;
        const sObjId = aParams.objId;
        const sName = aParams.name;
        const sAttrName = Commons.isAdoit() ? "A_REFERENCED_REPRESENTATION" : "REFERENCED_DOCUMENT";
        const sCurrentDocEncoded = aParams.fileEncoded;

        const sTemplateFileName = sName + ".docx";
        const sDocxMimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

        if (!(typeof sRepoId === "string" && 0 < sRepoId.length && typeof sObjId === "string" && 0 < sObjId.length))
        {
            console.warn("Cannot attach current document to the object! Object ID or repo ID is missing!");
            return;
        }

        let aBuffer = decode(sCurrentDocEncoded);
        let aFile = new File([aBuffer], sTemplateFileName,
        {
            type: sDocxMimeType
        });
        let aFormData = new FormData();
        aFormData.append("file", aFile, sTemplateFileName);

        // const sDocAttachReqUrl = Config.requests.sDocAttach.concat("&repo_id=", sRepoId, "&object_id=", sObjId, "&attribute_name=", sAttrName);
        await RequestHelper.sendRequestSimple(
        {
            request: Commons.createGatewayRequestUrl(
            {
                url: Config.anpRequestUrl.attachDoc
                    .replace(/%repo_id%/g, Config.aAnpRepo.id)
                    .replace(/%object_id%/g, sObjId)
                    .replace(/%attribute_name%/g, sAttrName),
                dataType: "text",
                endpoint: Config.requestDirectPutFile
            }),
            dataType: "text",
            body: aFormData,
            method: "PUT"
        }).then((aResponse) =>
        {
            if (aResponse && aResponse.isErr)
            {
                console.error(aResponse.message);
                throw new Error(aResponse.message)
            }
        });
    }

    static attachCurrentUserToObject = async (aParams) =>
    {
        try
        {
            const sObjId = aParams.objId;
            const sRepoId = Config.aAnpRepo.id;

            let aUser = {};

            if (!(typeof sObjId === "string" && 0 < sObjId.length && typeof sRepoId === "string" && 0 < sRepoId.length))
            {
                console.warn("Cannot attach current user to the object! Object ID od repo ID is missing!");
                return;
            }

            if(isOauth()){

                const Bearer = JSON.parse(localStorage.getItem("SSO-Credentials"));
                const aData = await RequestHelper.sendRequestSimple({
                    request: Commons.createGatewayRequestUrl({
                        url: Config.anpRequestUrl.me,
                        preventToken: true
                    }),
                    headers: {
                        "Authorization": "Bearer " + Bearer?.access_token
                    }
                });

                const { loginName } = JSON.parse(aData)

                localStorage.setItem('user_name',loginName)

            }

            const getUser = async () =>
            {
                await RequestHelper.sendRequestSimple(
                {
                    request: Commons.createGatewayRequestUrl(
                    {
                        url: Config.anpRequestUrl.getUser.replace(/%identification_method%/g, "login").replace(/%identifier%/g, localStorage["user_name"]),
                        dataType: "json"
                    }),
                    dataType: "json",
                }).then((aResponse) =>
                {
                    if (aResponse && aResponse.isErr)
                    {
                        console.error(aResponse.message);
                        throw new Error(aResponse.message)
                    }
                    if (aResponse.hasOwnProperty("user") && aResponse.user.hasOwnProperty("id") && aResponse.user.hasOwnProperty("loginName"))
                    {
                        aUser["id"] = Commons.removeCurlyBracketsFromId(aResponse.user.id);
                        aUser["name"] = aResponse.user.loginName;
                        if (aResponse.user.hasOwnProperty("sharedRepos"))
                        {
                            aUser["sharedRepos"] = aResponse.user.sharedRepos;
                        }
                        else
                        {
                            aUser["sharedRepos"] = [];
                        }
                    }
                    else
                    {
                        console.error("User cannot be found!");
                        throw new Error("User cannot be found!");
                    }
                });
            }
            await getUser();

            if (!(
                    aUser.hasOwnProperty("sharedRepos") &&
                    0 < aUser.sharedRepos.length &&
                    aUser.sharedRepos.find((aSharedRepo) =>
                    {
                        return Commons.removeCurlyBracketsFromId(aSharedRepo.id) === sRepoId
                    })
                ))
            {
                await RequestHelper.sendRequestSimple(
                {
                    request: Commons.createGatewayRequestUrl(
                    {
                        url: Config.anpRequestUrl.shareUser.replace(/%identification_method%/g, "login").replace(/%identifier%/g, localStorage["user_name"]),
                        dataType: "text"
                    }),
                    dataType: "text",
                    body: JSON.stringify(
                    {
                        id: sRepoId
                    }),
                    headers:
                    {
                        "Content-Type": "application/json"
                    },
                    method: "POST"
                }).then((aResponse) =>
                {
                    if (aResponse && aResponse.isErr)
                    {
                        console.error(aResponse.message);
                        if ("409: exists" !== aResponse.message)
                        {
                            throw new Error(aResponse.message)
                        }
                    }
                });
                await getUser();
            }

            const aEpCreationBody = {
                toId: aUser.id
            };
            await RequestHelper.sendRequestSimple(
            {
                request: Commons.createGatewayRequestUrl(
                {
                    url: Config.anpRequestUrl.createEndpoint
                        .replace(/%repo_id%/g, sRepoId)
                        .replace(/%object_id%/g, sObjId)
                        .replace(/%direction%/g, "outgoing")
                        .replace(/%rel_name%/g, (Commons.isAdoit() ? "RC_IS_APPLICATION_OWNER" : "RC_DOCUMENT_OWNER")),
                    dataType: "json"
                }),
                dataType: "text",
                headers:
                {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(aEpCreationBody),
                method: "POST"
            }).then((aResponse) =>
            {
                if (aResponse && aResponse.isErr)
                {
                    console.error(aResponse.message);
                    throw new Error(aResponse.message)
                }
            });
        }
        catch (aEx)
        {
            console.error("Assigning user to created document failed! Check your ADOxx REST API configuration.")
        }
    }
}